import serverClient, { browserClient } from '@/lib/apolloClient';
import { DictionarySubDirectory } from '@/lib/fragments/libraryUrlSubDirectory';
import { LIBRARY_URL_SUB_DIRECTORY_QUERY } from '@/lib/queries/urlSubDirectoryQuery';
import { isBrowser } from '@/helpers/is-browser';

// In the browser, route through the same-origin /api/graphql proxy so the
// Contentful token is never exposed. On the server, call Contentful directly.
const client = isBrowser ? browserClient : serverClient;

export interface DictionarySubDirectories {
  sys: {
    locale: string;
  };
  urlSubdirectory: string;
  contentTypes: string[];
}

// this is done only because of the data in contentful.
export const CONTENT_TYPE_MAP: Record<string, string> = {
  MeetingPlacePageOffer: 'ContentfulMeetingPlacePageOfferItem',
  MeetingPlacePageNewsItem: 'ContentfulMeetingPlacePageNewsItem',
  MeetingPlacePageEvent: 'ContentfulMeetingPlacePageEventItem',
  MeetingPlacePageLeisurePackageOfferItem:
    'ContentfulMeetingPlacePageLeisurePackageOfferItem',
  MeetingPlacePageTenantShop: 'ContentfulMeetingPlacePageTenantShopItem',
  MeetingPlacePageTenantEntertainment:
    'ContentfulMeetingPlacePageTenantEntertainmentItem',
  MeetingPlacePageTenantFoodBeverage:
    'ContentfulMeetingPlacePageTenantFoodBevItem',
  MeetingPlacePageService: 'ContentfulMeetingPlacePageServiceItem',
  // MeetingPlacePageServiceListCollection:
  //   'ContentfulLibraryServiceType',
};

export async function getDictionarySlugData(
  languageArray: string[],
  preview: boolean,
): Promise<DictionarySubDirectories[]> {
  try {
    const dictionarySlugData = await Promise.all(
      languageArray.map(async (lang): Promise<DictionarySubDirectories> => {
        const { data }: any = await client.query({
          query: LIBRARY_URL_SUB_DIRECTORY_QUERY,
          variables: { locale: lang, preview: preview },
          fetchPolicy: 'no-cache',
        });

        return data?.libraryUrlSubdirectoryCollection?.items;
      }),
    );

    return dictionarySlugData;
  } catch (error) {
    console.error('Error fetching dictionary slug data:', error);
    return [];
  }
}

export function getUrlSubdirectory(
  dictionaries: any,
  locale: string,
  contentType: string,
): string | null {
  // Find the dictionary for the specified locale
  // const dictionary = dictionaries.find((dict) => dict?.sys?.locale === locale);
  const dictionary = dictionaries.find((innerArr: any) =>
    innerArr.some((dict: any) => dict?.sys?.locale === locale),
  );

  if (!dictionary) {
    // console.warn(`No dictionary found for locale: ${locale}`);
    return null;
  }

  // Find the subdirectory item that contains the content type
  const subdirectory = dictionary.find(
    (item: any) =>
      item?.contentTypes.includes(contentType) ||
      item?.contentTypes.includes(CONTENT_TYPE_MAP[contentType]),
  );

  if (!subdirectory) {
    // console.warn(
    //   `No subdirectory found for contentType: ${contentType} in locale: ${locale}`,
    // );
    return null;
  }

  return subdirectory.urlSubdirectory;
}
